import { render, staticRenderFns } from "./ot-organisation-user-projects-index.vue?vue&type=template&id=ffa9f4c0&scoped=true&"
import script from "./ot-organisation-user-projects-index.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-user-projects-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-user-projects-index.vue?vue&type=style&index=0&id=ffa9f4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa9f4c0",
  null
  
)

export default component.exports